import { render, staticRenderFns } from "./GiftBoxBanner.vue?vue&type=template&id=8e37a718&scoped=true"
import script from "./GiftBoxBanner.vue?vue&type=script&lang=js"
export * from "./GiftBoxBanner.vue?vue&type=script&lang=js"
import style0 from "./GiftBoxBanner.vue?vue&type=style&index=0&id=8e37a718&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e37a718",
  null
  
)

export default component.exports